(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guia-modelo-marcas"] && !Shopify.designMode) return;
  try {
    
  /*
    <etg-brands> · filtra la tabla de marcas mientras se escribe.
    Sin JavaScript el filtro no aparece y la tabla se muestra entera.
    Ignora mayúsculas y tildes; busca también en los «otros nombres» del bloque.
  */
  (function () {
    if (!window.customElements || customElements.get('etg-brands')) return;

    function plain(text) {
      var value = (text || '').toLowerCase();
      return value.normalize ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : value;
    }

    class EtgBrands extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        var self = this;
        this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-etg-brand]'));
        this.filter = this.querySelector('[data-etg-filter]');
        this.empty = this.querySelector('[data-etg-empty]');
        if (!this.filter || this.rows.length < 2) return;

        var box = this.querySelector('[data-etg-filter-box]');
        if (box) box.hidden = false;
        this.filter.addEventListener('input', function () { self.apply(); });

        this.onEditorSelect = function (event) {
          var target = event.target;
          if (!self.contains(target) || !target.matches('[data-etg-brand]')) return;
          self.filter.value = '';
          self.apply();
          target.scrollIntoView({ block: 'center' });
        };
        document.addEventListener('shopify:block:select', this.onEditorSelect);
      }

      disconnectedCallback() {
        if (this.onEditorSelect) document.removeEventListener('shopify:block:select', this.onEditorSelect);
      }

      apply() {
        var query = plain(this.filter.value).trim();
        var visible = 0;
        this.rows.forEach(function (row) {
          var match = !query || plain(row.getAttribute('data-keywords')).indexOf(query) !== -1;
          row.hidden = !match;
          if (match) visible += 1;
        });
        if (this.empty) this.empty.hidden = visible !== 0;
      }
    }

    customElements.define('etg-brands', EtgBrands);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guia-modelo-old"] && !Shopify.designMode) return;
  try {
    
  /*
    <etg-guide> · mejora progresiva, sin dependencias ni variables globales.
    Sin JavaScript la página se lee y se navega igual (anclas y <details>).
    · Abre la ficha del aparato enlazado con #ancla (enlaces compartibles).
    · El campo de búsqueda abre el buscador de la cabecera (AgentSearch).
    · Marca en el índice el aparato que se está leyendo.
    · Ajusta los saltos a la altura real de la cabecera fija del tema.
    · En el editor de temas, al seleccionar un aparato lo muestra y lo abre.
  */
  (function () {
    if (!window.customElements || customElements.get('etg-guide')) return;

    class EtgGuide extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        var self = this;
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-etg-card]'));
        this.jumps = Array.prototype.slice.call(this.querySelectorAll('[data-etg-jump]'));

        this.jumps.forEach(function (link) {
          link.addEventListener('click', function () {
            self.openCard(self.cardFor(link.getAttribute('href').slice(1)));
          });
        });

        this.setupSearch();
        this.measureHeader();
        this.onResize = function () {
          clearTimeout(self.resizeTimer);
          self.resizeTimer = setTimeout(function () { self.measureHeader(); }, 150);
        };
        window.addEventListener('resize', this.onResize);

        this.onHash = function () { self.openCard(self.cardFor(self.hash())); };
        window.addEventListener('hashchange', this.onHash);
        this.onHash();

        this.watchCards();

        this.onEditorSelect = function (event) {
          var target = event.target;
          if (!self.contains(target) || !target.matches('[data-etg-card]')) return;
          self.openCard(target);
          target.scrollIntoView({ block: 'center' });
        };
        document.addEventListener('shopify:block:select', this.onEditorSelect);
      }

      disconnectedCallback() {
        if (this.onHash) window.removeEventListener('hashchange', this.onHash);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.onEditorSelect) document.removeEventListener('shopify:block:select', this.onEditorSelect);
        if (this.observer) this.observer.disconnect();
      }

      /*
        El buscador de la tienda (AgentSearch) vive en la cabecera y su capa solo
        se despliega bien desde allí. El botón de esta página no busca nada por su
        cuenta: reenvía el toque a la cabecera, como si se hubiera tocado la lupa.
      */
      headerField() {
        var selector = this.getAttribute('data-search-target');
        if (!selector) return null;
        try {
          var found = document.querySelectorAll(selector);
          for (var i = 0; i < found.length; i++) {
            if (!this.contains(found[i])) return found[i];
          }
        } catch (error) { /* selector no válido */ }
        return null;
      }

      setupSearch() {
        var self = this;
        var button = this.querySelector('[data-etg-search]');
        if (!button) return;
        button.addEventListener('click', function (event) {
          // Que este toque no cuente como «toque fuera» para el buscador recién abierto
          event.preventDefault();
          event.stopPropagation();
          if (!self.openStoreSearch()) {
            var url = button.getAttribute('data-search-url');
            if (url) window.location.assign(url);
          }
        });
      }

      // Reproduce un toque real sobre un elemento de la cabecera
      tap(target, focus) {
        var fire = function (type) {
          var Ctor = (type.indexOf('pointer') === 0 && window.PointerEvent) ? window.PointerEvent : MouseEvent;
          target.dispatchEvent(new Ctor(type, { bubbles: true, cancelable: true, view: window }));
        };
        fire('pointerdown'); fire('mousedown');
        if (focus && typeof target.focus === 'function') target.focus();
        fire('pointerup'); fire('mouseup');
        target.click();
      }

      openStoreSearch() {
        var field = this.headerField();
        if (!field) return false;
        var header = document.getElementById('shopify-section-header') || document;
        var toggle = header.querySelector('[data-action="toggle-search"]');
        var wrapper = field.closest('.header__search-bar-wrapper');
        var folded = wrapper ? !wrapper.classList.contains('is-visible') : field.offsetParent === null;

        // Móvil: el buscador está plegado tras la lupa. Se pulsa la lupa y nada más.
        if (folded && toggle && toggle.offsetParent !== null) { this.tap(toggle, false); return true; }
        // Ordenador (o buscador ya desplegado): se activa el campo de la cabecera.
        if (field.offsetParent !== null) { this.tap(field, true); return true; }
        return false;
      }

      /*
        La cabecera del tema no mide lo mismo en móvil que en escritorio. Si es
        fija (sticky o fixed), se usa su altura real para que los saltos a un
        ancla queden justo debajo. Si no se detecta, vale el ajuste de la sección.
      */
      measureHeader() {
        var section = document.getElementById('shopify-section-header');
        if (!section) return;
        var candidates = [section, section.firstElementChild];
        for (var i = 0; i < candidates.length; i++) {
          var el = candidates[i];
          if (!el) continue;
          var position = getComputedStyle(el).position;
          if (position === 'sticky' || position === 'fixed') {
            document.documentElement.style.setProperty('--etg-offset', Math.round(el.getBoundingClientRect().height) + 'px');
            return;
          }
        }
      }

      hash() {
        try { return decodeURIComponent(window.location.hash.slice(1)); } catch (error) { return ''; }
      }

      cardFor(id) {
        if (!id) return null;
        for (var i = 0; i < this.cards.length; i++) {
          if (this.cards[i].id === id) return this.cards[i];
        }
        return null;
      }

      openCard(card) {
        if (!card) return;
        var steps = card.querySelector('[data-etg-steps]');
        if (steps) steps.open = true;
      }

      watchCards() {
        if (!('IntersectionObserver' in window) || !this.jumps.length) return;
        var self = this;
        var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--etg-offset'), 10) || 0;
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            self.jumps.forEach(function (link) {
              if (link.getAttribute('href') === '#' + entry.target.id) link.setAttribute('aria-current', 'true');
              else link.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '-' + (offset + 24) + 'px 0px -65% 0px' });
        this.cards.forEach(function (card) { self.observer.observe(card); });
      }
    }

    customElements.define('etg-guide', EtgGuide);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guia-modelo"] && !Shopify.designMode) return;
  try {
    
  /*
    <etg-guide> · mejora progresiva, sin dependencias ni variables globales.
    Sin JavaScript la página se lee y se navega igual (anclas y <details>).
    · Abre la ficha del aparato enlazado con #ancla (enlaces compartibles).
    · El recuadro de búsqueda abre AgentSearch (ver openStoreSearch).
    · Marca en el índice el aparato que se está leyendo.
    · Ajusta los saltos a la altura real de la cabecera fija del tema.
    · En el editor de temas, al seleccionar un aparato lo muestra y lo abre.
  */
  (function () {
    if (!window.customElements || customElements.get('etg-guide')) return;

    class EtgGuide extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        var self = this;
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-etg-card]'));
        this.jumps = Array.prototype.slice.call(this.querySelectorAll('[data-etg-jump]'));

        this.jumps.forEach(function (link) {
          link.addEventListener('click', function () {
            self.openCard(self.cardFor(link.getAttribute('href').slice(1)));
          });
        });

        this.setupSearch();
        this.measureHeader();
        this.onResize = function () {
          clearTimeout(self.resizeTimer);
          self.resizeTimer = setTimeout(function () { self.measureHeader(); }, 150);
        };
        window.addEventListener('resize', this.onResize);

        this.onHash = function () { self.openCard(self.cardFor(self.hash())); };
        window.addEventListener('hashchange', this.onHash);
        this.onHash();

        this.watchCards();

        this.onEditorSelect = function (event) {
          var target = event.target;
          if (!self.contains(target) || !target.matches('[data-etg-card]')) return;
          self.openCard(target);
          target.scrollIntoView({ block: 'center' });
        };
        document.addEventListener('shopify:block:select', this.onEditorSelect);
      }

      disconnectedCallback() {
        if (this.onHash) window.removeEventListener('hashchange', this.onHash);
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.onEditorSelect) document.removeEventListener('shopify:block:select', this.onEditorSelect);
        if (this.observer) this.observer.disconnect();
      }

      /*
        Abre el buscador de la tienda (AgentSearch) desde el recuadro de la página.
        No depende de cómo esté montado el widget por dentro: busca, por este orden,
          1) el botón propio de AgentSearch, esté donde esté (también dentro de un
             shadow root abierto);
          2) el enlace o botón de búsqueda visible en la cabecera (la lupa);
          3) el campo de búsqueda del tema, si AgentSearch no está cargado;
        y pulsa el primero que encuentra. Nunca envía a la búsqueda de Shopify.
        Si la capa de AgentSearch sigue viviendo dentro de la cabecera, en móvil
        la saca al nivel superior de la página mientras está abierta.
      */
      setupSearch() {
        var self = this;
        var button = this.querySelector('[data-etg-search]');
        if (!button) return;
        button.addEventListener('click', function (event) {
          // Que este toque no cuente como «toque fuera» para el buscador recién abierto
          event.preventDefault();
          event.stopPropagation();
          self.openStoreSearch();
        });
      }

      // Shadow roots abiertos de la página (AgentSearch monta ahí su interfaz)
      shadowRoots() {
        var found = [];
        var known = document.getElementById('electrotodo-search-host');
        if (known && known.shadowRoot) found.push(known);
        var all = document.querySelectorAll('body *');
        for (var i = 0; i < all.length; i++) {
          if (all[i].shadowRoot && all[i] !== known && !this.contains(all[i])) found.push(all[i]);
        }
        return found;
      }

      // Enlace o botón de búsqueda a la vista en la cabecera del tema (la lupa en móvil)
      headerSearchControl(header) {
        if (!header) return null;
        var list = header.querySelectorAll('[data-action="toggle-search"], [data-search-toggle], [data-search-trigger], a[href$="/search"], a[href*="/search?"], button[aria-label], a[aria-label]');
        for (var i = 0; i < list.length; i++) {
          var el = list[i];
          if (el.offsetParent === null) continue;
          var href = el.getAttribute('href') || '';
          var label = (el.getAttribute('aria-label') || '').toLowerCase();
          var marked = el.hasAttribute('data-action') || el.hasAttribute('data-search-toggle') || el.hasAttribute('data-search-trigger');
          if (marked || /\/search(\?|$)/.test(href) || /search|buscar|b[uú]squeda|cerca|recherch|suche|pesquis|procurar|szuka|zoek/.test(label)) return el;
        }
        return null;
      }

      openStoreSearch() {
        var header = document.getElementById('shopify-section-header');
        var hosts = this.shadowRoots();
        var opener = null;
        var layerHost = null;
        var i;

        for (i = 0; i < hosts.length; i++) {
          var root = hosts[i].shadowRoot;
          if (!opener) opener = root.querySelector('.et-search-trigger, [data-search-trigger]');
          if (!layerHost && root.querySelector('.et-modal, [role="dialog"]')) layerHost = hosts[i];
        }
        if (!opener) {
          var loose = document.querySelectorAll('.et-search-trigger');
          for (i = 0; i < loose.length; i++) { if (!this.contains(loose[i])) { opener = loose[i]; break; } }
        }
        if (!opener) opener = this.headerSearchControl(header);

        if (opener) {
          var restore = layerHost ? this.liftSearchLayer(layerHost, header, opener) : null;
          opener.click();
          // Si la capa se movió y no consta como abierta, se deja todo como estaba
          if (restore && !document.documentElement.classList.contains('et-search-open')) restore();
          return true;
        }

        // Reserva, solo si AgentSearch no está cargado: el campo de búsqueda del tema
        var selector = this.getAttribute('data-search-target') || '.search-bar__input';
        var field = null;
        try { field = (header || document).querySelector(selector); } catch (error) { /* selector no válido */ }
        if (field && field.offsetParent !== null) { field.focus(); return true; }
        return false;
      }

      // Si la capa de AgentSearch está dentro de la cabecera, en móvil la saca al
      // nivel superior de la página mientras está abierta. Devuelve la función que
      // la recoloca, o null si no hace falta moverla.
      liftSearchLayer(host, header, opener) {
        // A partir de 768 px la capa es una ventana centrada y la cabecera no la tapa
        if (!window.matchMedia('(max-width: 767px)').matches) return null;
        // Solo si de verdad está dentro de la cabecera (si ya cuelga de la página, no se toca)
        if (!header || !header.contains(host)) return null;

        var root = document.documentElement;
        var home = host.parentNode;
        var next = host.nextSibling;
        var style = host.getAttribute('style');
        var inside = opener && host.shadowRoot && host.shadowRoot.contains(opener) ? opener : null;
        var insideDisplay = inside ? inside.style.display : '';
        var observer = null;
        var timer = null;
        var done = false;

        var restore = function () {
          if (done) return;
          done = true;
          if (observer) observer.disconnect();
          if (timer) clearInterval(timer);
          if (inside) inside.style.display = insideDisplay;
          if (style === null) host.removeAttribute('style'); else host.setAttribute('style', style);
          if (home && home.isConnected) home.insertBefore(host, next && next.parentNode === home ? next : null);
        };

        // Caja de tamaño cero, sin recorte, en lo más alto de la página: la capa y
        // su fondo son «fixed» y ocupan toda la pantalla, pero la caja en sí no
        // puede tapar ni bloquear nada, pase lo que pase al cerrar.
        document.body.appendChild(host);
        host.style.cssText = 'position: fixed; top: 0; left: 0; width: 0; height: 0; overflow: visible; z-index: 2147483647;';
        if (inside) inside.style.display = 'none';   // su botón no debe asomar mientras está fuera

        // AgentSearch marca <html> con «et-search-open» mientras la capa está abierta.
        // Se vigila por dos vías para recolocarla en cuanto se cierre.
        var check = function () { if (!root.classList.contains('et-search-open')) restore(); };
        observer = new MutationObserver(check);
        observer.observe(root, { attributes: true, attributeFilter: ['class'] });
        timer = setInterval(check, 400);
        return restore;
      }

      /*
        La cabecera del tema no mide lo mismo en móvil que en escritorio. Si es
        fija (sticky o fixed), se usa su altura real para que los saltos a un
        ancla queden justo debajo. Si no se detecta, vale el ajuste de la sección.
      */
      measureHeader() {
        var section = document.getElementById('shopify-section-header');
        if (!section) return;
        var candidates = [section, section.firstElementChild];
        for (var i = 0; i < candidates.length; i++) {
          var el = candidates[i];
          if (!el) continue;
          var position = getComputedStyle(el).position;
          if (position === 'sticky' || position === 'fixed') {
            document.documentElement.style.setProperty('--etg-offset', Math.round(el.getBoundingClientRect().height) + 'px');
            return;
          }
        }
      }

      hash() {
        try { return decodeURIComponent(window.location.hash.slice(1)); } catch (error) { return ''; }
      }

      cardFor(id) {
        if (!id) return null;
        for (var i = 0; i < this.cards.length; i++) {
          if (this.cards[i].id === id) return this.cards[i];
        }
        return null;
      }

      openCard(card) {
        if (!card) return;
        var steps = card.querySelector('[data-etg-steps]');
        if (steps) steps.open = true;
      }

      watchCards() {
        if (!('IntersectionObserver' in window) || !this.jumps.length) return;
        var self = this;
        var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--etg-offset'), 10) || 0;
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            self.jumps.forEach(function (link) {
              if (link.getAttribute('href') === '#' + entry.target.id) link.setAttribute('aria-current', 'true');
              else link.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '-' + (offset + 24) + 'px 0px -65% 0px' });
        this.cards.forEach(function (card) { self.observer.observe(card); });
      }
    }

    customElements.define('etg-guide', EtgGuide);
  })();

  } catch(e) { console.error(e); }
})();
})();
